import { render, staticRenderFns } from "./DSRDetailPage.vue?vue&type=template&id=20f77f79&scoped=true&"
import script from "./DSRDetailPage.vue?vue&type=script&lang=js&"
export * from "./DSRDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./DSRDetailPage.vue?vue&type=style&index=0&id=20f77f79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f77f79",
  null
  
)

export default component.exports